









































































import Vue from 'vue';

export default Vue.extend({
  name: 'Nav',
  data() {
    return {
      show: false,
    }
  },
  created() {
      this.show = true;
  },
  methods: {
    hide: function(){
      this.show = false;
    }
  }
});
